export const promotionRulesAndActions = {
  default: [
    // Rules
    'has_at_least_one_from_products',
    'cart_quantity',
    'customer_group',
    'nth_order',
    'has_taxon',
    'total_of_items_from_taxon',
    'contains_product',
    'item_total',
    'trade_in',
    // Actions
    'mgm_points_action',
    'unit_fixed_discount',
    'unit_percentage_discount',
    'shipping_percentage_discount',
    'nth_accessory_purchase',
    'nth_device_purchase',
    'group_of_products_discount',
    'bundle_fixed_discount',
    'discount_for_one_of_products',
    'starter_kit_unit_fixed_discount',
  ],
  tradein: [
    // Rules
    'trade_in',
    // Actions
    'mgm_points_action',
    'unit_fixed_discount',
    'unit_percentage_discount',
    'shipping_percentage_discount',
    'bundle_fixed_discount',
  ],
  mgm_lau_las: [
    // Rules
    'mgm_code_used',
    // Actions
    'mgm_discount',
    'shipping_percentage_discount',
  ],
  mgm_trade_in_lau_lau: [
    // Rules
    'trade_in',
    'mgm_code_used',
    // Actions
    'mgm_discount',
    'shipping_percentage_discount',
  ],
  bundle: [
    // Rules
    'has_at_least_one_from_products',
    'cart_quantity',
    'has_taxon',
    'total_of_items_from_taxon',
    'contains_product',
    'item_total',
    // Actions
    'bundle_fixed_discount',
    'mgm_points_action',
    'shipping_percentage_discount',
  ],
  one_to_many: [
    // Rules
    'has_at_least_one_from_products',
    'cart_quantity',
    'customer_group',
    'nth_order',
    'has_taxon',
    'total_of_items_from_taxon',
    'contains_product',
    'item_total',
    // Actions
    'mgm_points_action',
    'unit_fixed_discount',
    'unit_percentage_discount',
    'shipping_percentage_discount',
    'nth_accessory_purchase',
    'nth_device_purchase',
    'group_of_products_discount',
    'bundle_fixed_discount',
  ],
  coach: [
    // Rules
    'has_at_least_one_from_products',
    'cart_quantity',
    'customer_group',
    'nth_order',
    'has_taxon',
    'total_of_items_from_taxon',
    'contains_product',
    'item_total',
    // Actions
    'mgm_points_action',
    'unit_fixed_discount',
    'unit_percentage_discount',
    'shipping_percentage_discount',
    'nth_accessory_purchase',
    'nth_device_purchase',
    'group_of_products_discount',
    'bundle_fixed_discount',
  ],
  lowest_price_limit: [
    // Rules
    // Actions
    'lowest_price_limit',
  ],
  indirect_test_orders: [
    // Rules
    // Actions
    'indirect_test_orders',
  ],
};
